import { apiFetch, MOBILE_API } from "./api";

interface BulkProduct {
  productId: string;
  quantity: number;
  subtotal: number;
  expiryDate: string;
  discount: number;
}

export async function addProductToCart(
  userId: number,
  outletId: string,
  productId: string,
  quantity: number = 1
) {
  return apiFetch(`${MOBILE_API}/cart/${userId}/add/${outletId}/${productId}`, {
    method: "POST",
    body: { isCombo: false, quantity },
  });
}

export interface CheckoutSummary {
  validation: { isValid: boolean; reasons: string[] };
  outletId: string;
  items: unknown[];
  totalItems: number;
  priceBreakdown: {
    subtotal: number;
    discount: number;
    tax: number;
    deliveryFee: number;
    isDeliveryFeeApplicable: boolean;
    orderTotal: number;
    toPay: number;
  };
  appliedCoupon?: { code: string; discountAmount: number } | null;
}

export async function checkoutCart(userId: number, addressId?: number): Promise<{ response: { data: CheckoutSummary } }> {
  return apiFetch(`${MOBILE_API}/cart/${userId}/checkout`, {
    method: "PUT",
    body: { options: { orderPlacedfrom: "online", ...(addressId ? { addressId } : {}) } },
  }) as Promise<{ response: { data: CheckoutSummary } }>;
}

export async function getActiveCart(userId: number) {
  return apiFetch(`${MOBILE_API}/cart/${userId}`);
}

export async function removeProduct(userId: number, productId: string) {
  return apiFetch(`${MOBILE_API}/cart/${userId}/remove/${productId}`, {
    method: "PUT",
  });
}

export async function deleteCart(userId: number) {
  return apiFetch(`${MOBILE_API}/cart/${userId}/delete`, {
    method: "PUT",
  });
}

export async function applyCoupon(
  userId: number,
  couponId: number,
  outletId: string
) {
  return apiFetch(`${MOBILE_API}/cart/${userId}/apply-coupon`, {
    method: "POST",
    body: { couponId, outletId },
  });
}

export async function removeCoupon(userId: number) {
  return apiFetch(`${MOBILE_API}/cart/${userId}/remove-coupon`, {
    method: "DELETE",
  });
}

export async function addComboToCart(
  userId: number,
  comboId: number,
  outletId: string,
  quantity: number = 1
) {
  return apiFetch(`${MOBILE_API}/cart/${userId}/combo/add`, {
    method: "POST",
    body: { comboId, outletId, quantity },
  });
}
